module.exports = __webpack_public_path__ + "static/media/Owner.ea91044e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/JoinSubscription/Owner.svg
// module id = 359
// module chunks = 0